// table_group: кнопка «Показать ещё» с прелоадером.

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    componentId: String,
    perPage: Number,
    totalGroups: Number,
    offset: Number,
    view: { type: String, default: "dae20" }
  }

  static targets = ["body", "bodyMobile", "moreBtn", "moreBtnMobile", "summary"]

  async loadMore(event) {
    const type = event.currentTarget.dataset.type || "desktop"
    if (this.offsetValue >= this.totalGroupsValue) return

    const btn = type === "desktop" ? this.moreBtnTarget : this.moreBtnMobileTarget
    const labelEl = btn.querySelector('[data-label]')
    const spinnerEl = btn.querySelector('.tg-spinner')
    const remainingEl = btn.querySelector('.text-gray-400')

    btn.disabled = true
    labelEl.textContent = 'Загрузка...'
    spinnerEl?.classList.remove('hidden')

    let loaded = 0

    try {
      const url = `/dae20/table_group_rows?component_id=${this.componentIdValue}&offset=${this.offsetValue}&per_page=${this.perPageValue}&view=${this.viewValue}`
      const response = await fetch(url, {
        headers: { "Accept": "text/vnd.turbo-stream.html" }
      })
      if (!response.ok) return

      const html = await response.text()
      const doc = new DOMParser().parseFromString(html, "text/html")
      const turboTemplate = doc.querySelector("template")
      if (!turboTemplate) return

      const rowTemplates = turboTemplate.content.querySelectorAll("template[data-tg-row]")
      if (rowTemplates.length === 0) return

      const container = type === "desktop" ? this.bodyTarget : this.bodyMobileTarget
      rowTemplates.forEach((tmpl) => {
        container.insertBefore(tmpl.content.cloneNode(true), btn)
      })

      loaded = rowTemplates.length
      this.offsetValue += loaded

      // Summary
      if (this.hasSummaryTarget) {
        const total = this.totalGroupsValue
        const parent = this.summaryTarget.parentElement
        if (parent) {
          parent.innerHTML = `Групп: <span class="font-semibold text-gray-700" data-dae20--table-group-target="summary">${Math.min(this.offsetValue, total)}</span> из <span class="font-semibold text-gray-700">${total}</span>`
        }
      }

      // Всё загружено — убираем кнопку
      if (this.offsetValue >= this.totalGroupsValue) {
        btn.remove()
        return
      }
    } catch (error) {
      console.error("[table_group] loadMore error:", error)
    }

    if (!btn.isConnected) return

    btn.disabled = false
    const remaining = this.totalGroupsValue - this.offsetValue
    const nextCount = Math.min(this.perPageValue, remaining)
    labelEl.textContent = `Показать ещё ${nextCount}`
    if (remainingEl) remainingEl.textContent = `(${remaining} осталось)`
    spinnerEl?.classList.add('hidden')
  }
}
